import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchHomeData(userData: any) {
  const response = await instance.post(
    //`/users/getHomePageData?userId=${userData.UserId}&companyId=${userData.companyId}`
    `/users/getHomePageData`
  );
  // const data = await response.data;
  return response.data;
}
export async function fetchRecentUpdateData(data: any) {
  const response = await instance.get(
    `/admin/recentUpdates/get?offset=${data}`
  );
  // const data = await response.data;
  return response.data;
}
